var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 3.33366C1.875 2.06801 2.90102 1.04199 4.16667 1.04199H15.8333C17.099 1.04199 18.125 2.06801 18.125 3.33366V4.15973C18.125 4.50491 17.8452 4.78473 17.5 4.78473C17.1548 4.78473 16.875 4.50491 16.875 4.15973V3.33366C16.875 2.75836 16.4087 2.29199 15.8333 2.29199H4.16667C3.59137 2.29199 3.125 2.75836 3.125 3.33366V16.667C3.125 17.2423 3.59137 17.7087 4.16667 17.7087H15.8333C16.4087 17.7087 16.875 17.2423 16.875 16.667V7.52576C16.875 7.18058 17.1548 6.90076 17.5 6.90076C17.8452 6.90076 18.125 7.18058 18.125 7.52576V16.667C18.125 17.9327 17.099 18.9587 15.8333 18.9587H4.16667C2.90102 18.9587 1.875 17.9327 1.875 16.667V3.33366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 16.25C8.125 15.9048 8.40483 15.625 8.75 15.625H11.25C11.5952 15.625 11.875 15.9048 11.875 16.25C11.875 16.5952 11.5952 16.875 11.25 16.875H8.75C8.40483 16.875 8.125 16.5952 8.125 16.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 4.375C5.90482 4.375 5.625 4.65482 5.625 5C5.625 5.34518 5.90482 5.625 6.25 5.625C6.59518 5.625 6.875 5.34518 6.875 5C6.875 4.65482 6.59518 4.375 6.25 4.375ZM4.375 5C4.375 3.96447 5.21447 3.125 6.25 3.125C7.28553 3.125 8.125 3.96447 8.125 5C8.125 6.03553 7.28553 6.875 6.25 6.875C5.21447 6.875 4.375 6.03553 4.375 5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95833 6.25C8.95833 5.90483 9.23816 5.625 9.58333 5.625H14.5833C14.9285 5.625 15.2083 5.90483 15.2083 6.25C15.2083 6.59517 14.9285 6.875 14.5833 6.875H9.58333C9.23816 6.875 8.95833 6.59517 8.95833 6.25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95833 3.75C8.95833 3.40483 9.23816 3.125 9.58333 3.125H11.25C11.5952 3.125 11.875 3.40483 11.875 3.75C11.875 4.09517 11.5952 4.375 11.25 4.375H9.58333C9.23816 4.375 8.95833 4.09517 8.95833 3.75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 10.209C5.90482 10.209 5.625 10.4888 5.625 10.834C5.625 11.1792 5.90482 11.459 6.25 11.459C6.59518 11.459 6.875 11.1792 6.875 10.834C6.875 10.4888 6.59518 10.209 6.25 10.209ZM4.375 10.834C4.375 9.79848 5.21447 8.95898 6.25 8.95898C7.28553 8.95898 8.125 9.79848 8.125 10.834C8.125 11.8695 7.28553 12.709 6.25 12.709C5.21447 12.709 4.375 11.8695 4.375 10.834Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95833 12.084C8.95833 11.7388 9.23816 11.459 9.58333 11.459H14.5833C14.9285 11.459 15.2083 11.7388 15.2083 12.084C15.2083 12.4292 14.9285 12.709 14.5833 12.709H9.58333C9.23816 12.709 8.95833 12.4292 8.95833 12.084Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95833 9.58398C8.95833 9.23882 9.23816 8.95898 9.58333 8.95898H11.25C11.5952 8.95898 11.875 9.23882 11.875 9.58398C11.875 9.92915 11.5952 10.209 11.25 10.209H9.58333C9.23816 10.209 8.95833 9.92915 8.95833 9.58398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerListIcon);
export default __webpack_public_path__ + "static/media/partner-list-icon.0193e75672a9639a32ba39dc1c8d328f.svg";
export { ForwardRef as ReactComponent };